import { lbBrand } from '@fuse/colors';
import FuseAnimate from '@fuse/core/FuseAnimate';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import JWTLoginTab from './tabs/JWTLoginTab';

const useStyles = makeStyles(theme => ({
  root: {
    background: lbBrand.authGradient,
    color: theme.palette.primary.contrastText,
    position: 'relative',
    overflow: 'hidden',
  },
  decoration: {
    position: 'absolute',
    top: '45%',
    right: '-200px',
    height: '120%',
    width: 'auto',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
    opacity: 0.45,
    zIndex: 0,
  },
  content: {
    position: 'relative',
    zIndex: 1,
  },
}));

function Login() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div
      className={clsx(classes.root, 'flex flex-col flex-auto items-center justify-center flex-shrink-0 p-16 md:p-24')}
    >
      <img className={clsx(classes.decoration, 'hidden md:block')} src="assets/images/login/login-waves.svg" alt="" />

      <FuseAnimate animation="transition.expandIn">
        <div className={clsx(classes.content, 'flex flex-col items-center w-full max-w-400')}>
          <FuseAnimate delay={300}>
            <div className="flex justify-center mb-40">
              <img className="w-full max-w-320" src="assets/images/logos/LB-lockup-on-dark.png" alt="LittleBill" />
            </div>
          </FuseAnimate>

          <Card
            className="flex flex-col w-full items-center justify-center rounded-12 shadow-2xl overflow-hidden"
            elevation={0}
          >
            <CardContent className="flex flex-col items-center justify-center w-full py-48 px-32">
              <JWTLoginTab />
            </CardContent>
          </Card>

          <div className="flex flex-col items-center mt-24 text-center">
            <Typography className="text-13 font-700" color="inherit">
              {t('pages.login.supportPhone')}
            </Typography>
            <Typography className="text-13 font-700" color="inherit">
              {t('pages.login.supportEmail')}
            </Typography>
          </div>
        </div>
      </FuseAnimate>
    </div>
  );
}

export default Login;
